import { updates } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-extrabold text-foreground-950 font-heading mb-3">
            最新快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            实时追踪娱乐圈最新动态，第一时间为你呈现最热门爆料
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, i) => (
            <div
              key={i}
              className="relative pl-8 pb-8 last:pb-0 group"
            >
              <div className="absolute left-0 top-1.5 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-primary-100 z-10"></div>
              {i < updates.length - 1 && (
                <div className="absolute left-[5px] top-5 bottom-0 w-0.5 bg-background-200"></div>
              )}

              <div className="bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200 transition-colors">
                <div className="flex items-center gap-3 mb-2 flex-wrap">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    <i className="ri-time-line mr-1"></i>
                    {item.time}
                  </span>
                  <span className="px-2 py-0.5 text-[11px] font-semibold rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2 font-heading">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.summary}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}